import BaseModel from '../base/BaseModel.model';
import { CurriculumSource } from '@/enums/curriculumSource';
import PublicationDocument from './publicationDocument.Model';
export default class PublicactionUser extends BaseModel {
    public userId?: number;
    public publicationTitle?: string;
    public publicationYear?:  Date | any;
    public source?: CurriculumSource | null;
    public url?:  string;
    public sourceDescription?: string;
    public publicationDocuments : Array<PublicationDocument> = [];
    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.source = null;
        this.place = "";   
        this.sourceDescription = "";
        this.PublicationDocuments = [];
    }
}